import React, { memo } from 'react';
import './Card.scss';
import { Tooltip } from 'primereact/tooltip';

interface CardProps {
    event: {
        timeText?: string;
        title?: string;
        espacio?: string;
        colorArea?: string;
        reservadoPor?: string;
        reservadoPara?: string;
        descripcion?: string;
    };
}

const Card = memo(({ event }: CardProps) => {
    const { timeText = '', title = '', espacio = '', colorArea = '' } = event;
    
    return (
        <div className='w-full h-full'>
            <div 
                className='custom-target-icon flex flex-row w-full h-full justify-content-between overflow-hidden imj-card'
                data-pr-tooltip={`${timeText} ${title} ${espacio ? "(" + espacio + ")" : ""}`}
            >
                <div className='imj-card-section1 flex w-full justify-content-center align-items-center overflow-hidden mr-1 flex-wrap'>
                    <i className='card-week-and-day-time mr-2'>{timeText} {title} {espacio}</i>
                    {/* <i className='card-week-and-day-title imj-card-title mr-2'>{title}</i>
                    <i className='card-week-and-day-title imj-card-title'>{espacio}</i> */}
                </div>
                <div 
                    className='imj-card-area-background' 
                    style={{ 
                        backgroundColor: colorArea || '#e8474fc7'
                    }}
                />
            </div>
            <Tooltip target=".custom-target-icon" mouseTrack/>
        </div>
        // <div className='w-full h-full'>
        //     <div className='flex flex-row w-full h-full justify-content-between overflow-hidden imj-card custom-target-icon'
        //         data-pr-tooltip={`${timeText} ${title} ${espacio ? "(" + espacio + ")" : ""}`}>
        //         <div className='flex w-full justify-content-center align-items-center overflow-hidden mr-1 flex-wrap'>
        //             {/* <b className='mr-2'>{event.timeText}</b> */}
        //             <i className='mr-2'>{event.timeText} {event.title} {event.espacio}</i>
        //         </div>
        //         <div 
        //             className='imj-card-area-background' 
        //             style={{ 
        //                 backgroundColor: colorArea || '#e8474fc7'
        //             }}
        //         />
        //     </div>
        //     <Tooltip target=".custom-target-icon" mouseTrack/>
        // </div>
    );
});

Card.displayName = 'Card';

export default Card;